/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

export function updateInvoiceTranslationInfo(model: any, defaultTranslations: Record<string, any>): void {
  model.specifyLocale = !!model.locale;
  if (defaultTranslations && (!model.translations || _.isEmpty(model.translations))) {
    model.translations = _.cloneDeep(defaultTranslations);
  }
}

export function initInvoiceTranslationModel(model: any, defaultTranslations: Record<string, any>): void {
  if (!model.translations) {
    model.translations = {};
  }
  updateInvoiceTranslationInfo(model, defaultTranslations);
}

export function prepareInvoiceTranslationForSubmit(model: any, defaultTranslations: Record<string, any>): void {
  if (!model.specifyLocale) {
    model.locale = '';
  }
  if (_.isEqual(model.translations, defaultTranslations)) {
    model.translations = null;
  }
}

export function getInvoiceTranslationKeys(defaultTranslations: Record<string, any>): string[] {
  return defaultTranslations ? Object.keys(defaultTranslations) : [];
}

export function normalizeInvoiceLogoUrl(logoUrl: string): string {
  return logoUrl && logoUrl.indexOf('//') === 0 ? 'https:' + logoUrl : logoUrl;
}

export function getInvoicePaymentProvider(LocalNetworkProfile: any): string {
  return LocalNetworkProfile.getPaymentProvider().replace('_SANDBOX', '').replace('_TEST', '');
}

export function isInvoicePreviewSupported(paymentProvider: string): boolean {
  return paymentProvider === 'BNP_PARIBAS' || paymentProvider === 'PAYPAL' || paymentProvider === 'PIN_PAYMENTS';
}
